import React from "react";
import DatePickerComponent from "../views/dashboard/date/date";
import BOMOne from "../views/dashboard/job/bomOne";
import BOMTwo from "../views/dashboard/job/bomTwo";
import BOMOnePrint from "../views/dashboard/job/bomOnePrint";

export const PublicTestRouter = [
  {
    path: "date",
    element: <DatePickerComponent />,
  },
  {
    path: "bom",
    element: <BOMOne />,
  },
  {
    path: "system-wise-bom",
    element: <BOMTwo />,
  },
  {
    path: "bom-print",
    element: <BOMOnePrint />,
  },
];
